<template lang="pug">
	.banner-control
		.title {{title}}
		.banner-options-button(v-pseudo-modal-show="this._uid + 'banner-control-dropdown'" :class="`banner-template-${currentBannerId}`")
		div.dropdown-menu.dropdown-menu-right(v-pseudo-modal="this._uid + 'banner-control-dropdown'")
			.dropdown-item.banner-template.banner-template-0(@click="setBanner(0)")
			.dropdown-item.banner-template.banner-template-1(@click="setBanner(1)")
			.dropdown-item.banner-template.banner-template-2(@click="setBanner(2)")
			.dropdown-item.banner-template.banner-template-3(@click="setBanner(3)")
			.dropdown-item.banner-template.banner-template-4(@click="setBanner(4)")
			.dropdown-item.banner-template.banner-template-5(@click="setBanner(5)")
			.dropdown-item.banner-template.banner-template-6(@click="setBanner(6)")

</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Settings }			from './../../services/Settings';

	export default {
		name: "BannerTemplatesList",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Switched", "Selected Version Fully Loaded"]
		},
		props: ['prefix', 'title'],
		data() {

			this.settings = [
				{
					bottom: {
						"bottom-banner": true,
						"bottom-banner-button-animation": true,
						"bottom-banner-rating": 90,
						"bottom-banner-rating-styles": {"width": 400, "height": 70, "left": 240, "top": 150, "display": "block"},
						"bottom-banner-background-styles": {"width": 1240, "bottom": 0, "left": -620, "borderRadius": 20, "backgroundColor": "#ffffff", "opacity": 1},
						"bottom-banner-content-styles": {"width": 1240, "bottom": 0, "left": -620},
						"bottom-banner-icon-styles": {"width": 200, "height": 200, "left": 25, "top": 26, "borderRadius": 40},
						"bottom-banner-title-text": "Slices",
						"bottom-banner-title-styles": {"left": 250, "top": 10, "color": "#333333", "fontFamily": "Arial", "fontSize": 80, "fontWeight": "400", "fontStyle": "normal"},
						"bottom-banner-description-text": "",
						"bottom-banner-description-styles": {"display": "none"},
						"bottom-banner-button-text": "Download",
						"bottom-banner-button-styles": {"width": 380, "height": 140, "left": 830, "top": 60, "lineHeight": 140, "backgroundColor": "#0fc300", "color": "#ffffff", "borderRadius": 40, "fontFamily": "Arial", "fontSize": 70, "fontWeight": "400", "fontStyle": "normal"},
						"bottom-banner-cta-text-0-text": "",
						"bottom-banner-cta-text-0-styles": {"display": "none"},
						"bottom-banner-cta-text-1-text": "",
						"bottom-banner-cta-text-1-styles": {"display": "none"},
						"bottom-banner-star-styles": {"display": "none"},
						"bottom-banner-comment-styles": {"display": "none"},
						"bottom-banner-comment-duration": 0,
						"bottom-banner-comment-0-rating": 95,
						"bottom-banner-comment-0-name": "",
						"bottom-banner-comment-0-text": "",
						"bottom-banner-comment-1-rating": 100,
						"bottom-banner-comment-1-name": "",
						"bottom-banner-comment-1-text": "",
						"bottom-banner-comment-2-rating": 80,
						"bottom-banner-comment-2-name": "",
						"bottom-banner-comment-2-text": "",
						"bottom-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"bottom-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					},
					top: {
						"top-banner": true,
						"top-banner-button-animation": true,
						"top-banner-rating": 90,
						"top-banner-rating-styles": {"width": 400, "height": 70, "left": 240, "top": 150, "display": "block"},
						"top-banner-background-styles": {"width": 1240, "top": 0, "left": -620, "borderRadius": 20, "backgroundColor": "#ffffff", "opacity": 1},
						"top-banner-content-styles": {"width": 1240, "top": 0, "left": -620},
						"top-banner-icon-styles": {"width": 200, "height": 200, "left": 25, "top": 26, "borderRadius": 40},
						"top-banner-title-text": "Slices",
						"top-banner-title-styles": {"left": 250, "top": 10, "color": "#333333", "fontFamily": "Arial", "fontSize": 80, "fontWeight": "400", "fontStyle": "normal"},
						"top-banner-description-text": "",
						"top-banner-description-styles": {"display": "none"},
						"top-banner-button-text": "Download",
						"top-banner-button-styles": {"width": 380, "height": 140, "left": 830, "top": 60, "lineHeight": 140, "backgroundColor": "#0fc300", "color": "#ffffff", "borderRadius": 40, "fontFamily": "Arial", "fontSize": 70, "fontWeight": "400", "fontStyle": "normal"},
						"top-banner-cta-text-0-text": "",
						"top-banner-cta-text-0-styles": {"display": "none"},
						"top-banner-cta-text-1-text": "",
						"top-banner-cta-text-1-styles": {"display": "none"},
						"top-banner-star-styles": {"display": "none"},
						"top-banner-comment-styles": {"display": "none"},
						"top-banner-comment-duration": 0,
						"top-banner-comment-0-rating": 95,
						"top-banner-comment-0-name": "",
						"top-banner-comment-0-text": "",
						"top-banner-comment-1-rating": 100,
						"top-banner-comment-1-name": "",
						"top-banner-comment-1-text": "",
						"top-banner-comment-2-rating": 80,
						"top-banner-comment-2-name": "",
						"top-banner-comment-2-text": "",
						"top-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"top-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					}
				},
				{
					bottom: {
						"bottom-banner": true,
						"bottom-banner-button-animation": true,
						"bottom-banner-rating": 90,
						"bottom-banner-rating-styles": {"width": 250, "height": 40, "left": 247, "top": 160, "display": "block"},
						"bottom-banner-background-styles": {"width": 1240, "bottom": 0, "left": -620, "borderRadius": 20, "backgroundColor": "#ffffff", "opacity": 1},
						"bottom-banner-content-styles": {"width": 1240, "bottom": 0, "left": -620},
						"bottom-banner-icon-styles": {"width": 200, "height": 200, "left": 25, "top": 26, "borderRadius": 20},
						"bottom-banner-title-text": "Slices",
						"bottom-banner-title-styles": {"left": 250, "top": 15, "color": "#333333", "fontFamily": "Arial", "fontSize": 80, "fontWeight": "400", "fontStyle": "normal"},
						"bottom-banner-description-text": "Good Job Games",
						"bottom-banner-description-styles": {"left": 250, "top": 100, "color": "#777777", "fontFamily": "Arial", "fontSize": 45, "fontWeight": "400", "fontStyle": "normal"},
						"bottom-banner-button-text": "Download",
						"bottom-banner-button-styles": {"width": 380, "height": 130, "left": 800, "top": 90, "lineHeight": 130, "backgroundColor": "#00a2da", "color": "#ffffff", "borderRadius": 70, "fontFamily": "Arial", "fontSize": 50, "fontWeight": "600", "fontStyle": "normal"},
						"bottom-banner-cta-text-0-text": "№1",
						"bottom-banner-cta-text-0-styles": {"left": 855, "top": 23, "color": "#555555", "fontFamily": "Arial", "fontSize": 60, "fontWeight": "600", "fontStyle": "normal"},
						"bottom-banner-cta-text-1-text": "Games",
						"bottom-banner-cta-text-1-styles": {"left": 965, "top": 35, "color": "#777777", "fontFamily": "Arial", "fontSize": 45, "fontWeight": "400", "fontStyle": "normal"},
						"bottom-banner-star-styles": {"display": "none"},
						"bottom-banner-comment-styles": {"display": "none"},
						"bottom-banner-comment-duration": 0,
						"bottom-banner-comment-0-rating": 95,
						"bottom-banner-comment-0-name": "",
						"bottom-banner-comment-0-text": "",
						"bottom-banner-comment-1-rating": 100,
						"bottom-banner-comment-1-name": "",
						"bottom-banner-comment-1-text": "",
						"bottom-banner-comment-2-rating": 80,
						"bottom-banner-comment-2-name": "",
						"bottom-banner-comment-2-text": "",
						"bottom-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"bottom-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					},
					top: {
						"top-banner": true,
						"top-banner-button-animation": true,
						"top-banner-rating": 90,
						"top-banner-rating-styles": {"width": 250, "height": 40, "left": 247, "top": 160, "display": "block"},
						"top-banner-background-styles": {"width": 1240, "top": 0, "left": -620, "borderRadius": 20, "backgroundColor": "#ffffff", "opacity": 1},
						"top-banner-content-styles": {"width": 1240, "top": 0, "left": -620},
						"top-banner-icon-styles": {"width": 200, "height": 200, "left": 25, "top": 26, "borderRadius": 20},
						"top-banner-title-text": "Slices",
						"top-banner-title-styles": {"left": 250, "top": 15, "color": "#333333", "fontFamily": "Arial", "fontSize": 80, "fontWeight": "400", "fontStyle": "normal"},
						"top-banner-description-text": "Good Job Games",
						"top-banner-description-styles": {"left": 250, "top": 100, "color": "#777777", "fontFamily": "Arial", "fontSize": 45, "fontWeight": "400", "fontStyle": "normal"},
						"top-banner-button-text": "Download",
						"top-banner-button-styles": {"width": 380, "height": 130, "left": 800, "top": 90, "lineHeight": 130, "backgroundColor": "#00a2da", "color": "#ffffff", "borderRadius": 70, "fontFamily": "Arial", "fontSize": 50, "fontWeight": "600", "fontStyle": "normal"},
						"top-banner-cta-text-0-text": "№1",
						"top-banner-cta-text-0-styles": {"left": 855, "top": 23, "color": "#555555", "fontFamily": "Arial", "fontSize": 60, "fontWeight": "600", "fontStyle": "normal"},
						"top-banner-cta-text-1-text": "Games",
						"top-banner-cta-text-1-styles": {"left": 965, "top": 35, "color": "#777777", "fontFamily": "Arial", "fontSize": 45, "fontWeight": "400", "fontStyle": "normal"},
						"top-banner-star-styles": {"display": "none"},
						"top-banner-comment-styles": {"display": "none"},
						"top-banner-comment-duration": 0,
						"top-banner-comment-0-rating": 95,
						"top-banner-comment-0-name": "",
						"top-banner-comment-0-text": "",
						"top-banner-comment-1-rating": 100,
						"top-banner-comment-1-name": "",
						"top-banner-comment-1-text": "",
						"top-banner-comment-2-rating": 80,
						"top-banner-comment-2-name": "",
						"top-banner-comment-2-text": "",
						"top-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"top-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					}
				},
				{
					bottom: {
						"bottom-banner": true,
						"bottom-banner-button-animation": true,
						"bottom-banner-rating": 90,
						"bottom-banner-rating-styles": {"display": "none"},
						"bottom-banner-background-styles": {"width": 1240, "bottom": 0, "left": -620, "borderRadius": 20, "backgroundColor": "#ffffff", "opacity": 1},
						"bottom-banner-content-styles": {"width": 1240, "bottom": 0, "left": -620},
						"bottom-banner-icon-styles": {"width": 200, "height": 200, "left": 25, "top": 26, "borderRadius": 20},
						"bottom-banner-title-text": "SLICES",
						"bottom-banner-title-styles": {"left": 250, "top": 110, "color": "#333333", "fontFamily": "Anton-Regular", "fontSize": 80, "fontWeight": "900", "fontStyle": "normal"},
						"bottom-banner-description-text": "Good Job Games",
						"bottom-banner-description-styles": {"left": 250, "top": 50, "color": "#333333", "fontFamily": "Anton-Regular", "fontSize": 60, "fontWeight": "900", "fontStyle": "normal"},
						"bottom-banner-button-text": "DOWNLOAD",
						"bottom-banner-button-styles": {"width": 500, "height": 180, "left": 720, "top": 35, "lineHeight": 180, "backgroundColor": "#ea422e", "color": "#ffffff", "borderRadius": 20, "fontFamily": "Anton-Regular", "fontSize": 70, "fontWeight": "400", "fontStyle": "normal"},
						"bottom-banner-cta-text-0-text": "",
						"bottom-banner-cta-text-0-styles": {"display": "none"},
						"bottom-banner-cta-text-1-text": "",
						"bottom-banner-cta-text-1-styles": {"display": "none"},
						"bottom-banner-star-styles": {"display": "none"},
						"bottom-banner-comment-styles": {"display": "none"},
						"bottom-banner-comment-duration": 0,
						"bottom-banner-comment-0-rating": 95,
						"bottom-banner-comment-0-name": "",
						"bottom-banner-comment-0-text": "",
						"bottom-banner-comment-1-rating": 100,
						"bottom-banner-comment-1-name": "",
						"bottom-banner-comment-1-text": "",
						"bottom-banner-comment-2-rating": 80,
						"bottom-banner-comment-2-name": "",
						"bottom-banner-comment-2-text": "",
						"bottom-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"bottom-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					},
					top: {
						"top-banner": true,
						"top-banner-button-animation": true,
						"top-banner-rating": 90,
						"top-banner-rating-styles": {"display": "none"},
						"top-banner-background-styles": {"width": 1240, "top": 0, "left": -620, "borderRadius": 20, "backgroundColor": "#ffffff", "opacity": 1},
						"top-banner-content-styles": {"width": 1240, "top": 0, "left": -620},
						"top-banner-icon-styles": {"width": 200, "height": 200, "left": 25, "top": 26, "borderRadius": 20},
						"top-banner-title-text": "SLICES",
						"top-banner-title-styles": {"left": 250, "top": 110, "color": "#333333", "fontFamily": "Anton-Regular", "fontSize": 80, "fontWeight": "900", "fontStyle": "normal"},
						"top-banner-description-text": "Good Job Games",
						"top-banner-description-styles": {"left": 250, "top": 50, "color": "#333333", "fontFamily": "Anton-Regular", "fontSize": 60, "fontWeight": "900", "fontStyle": "normal"},
						"top-banner-button-text": "DOWNLOAD",
						"top-banner-button-styles": {"width": 500, "height": 180, "left": 720, "top": 35, "lineHeight": 180, "backgroundColor": "#ea422e", "color": "#ffffff", "borderRadius": 20, "fontFamily": "Anton-Regular", "fontSize": 70, "fontWeight": "400", "fontStyle": "normal"},
						"top-banner-cta-text-0-text": "",
						"top-banner-cta-text-0-styles": {"display": "none"},
						"top-banner-cta-text-1-text": "",
						"top-banner-cta-text-1-styles": {"display": "none"},
						"top-banner-star-styles": {"display": "none"},
						"top-banner-comment-styles": {"display": "none"},
						"top-banner-comment-duration": 0,
						"top-banner-comment-0-rating": 95,
						"top-banner-comment-0-name": "",
						"top-banner-comment-0-text": "",
						"top-banner-comment-1-rating": 100,
						"top-banner-comment-1-name": "",
						"top-banner-comment-1-text": "",
						"top-banner-comment-2-rating": 80,
						"top-banner-comment-2-name": "",
						"top-banner-comment-2-text": "",
						"top-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"top-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					}
				},
				{
					bottom: {
						"bottom-banner": true,
						"bottom-banner-button-animation": false,
						"bottom-banner-rating": 90,
						"bottom-banner-rating-styles": {"display": "none"},
						"bottom-banner-background-styles": {"width": 6000, "bottom": 0, "left": -3000, "borderRadius": 0, "backgroundColor": "#ffffff", "opacity": 1, "display": "block"},
						"bottom-banner-content-styles": {"width": 6000, "bottom": 0, "left": -3000, "display": "block"},
						"bottom-banner-icon-styles": {"display": "none"},
						"bottom-banner-title-text": "banner x",
						"bottom-banner-title-styles": {"width": 6000, "left": 0, "top": 10, "height": "100%", "color": "#d3028b", "fontFamily": "Arista-Pro-Alternate-Regular", "fontSize": 150, "fontWeight": "400", "fontStyle": "normal", "textAlign": "center", "lineHeight": 250, "display": "block"},
						"bottom-banner-description-text": "",
						"bottom-banner-description-styles": {"display": "none"},
						"bottom-banner-button-text": "",
						"bottom-banner-button-styles": {"display": "none"},
						"bottom-banner-cta-text-0-text": "",
						"bottom-banner-cta-text-0-styles": {"display": "none"},
						"bottom-banner-cta-text-1-text": "",
						"bottom-banner-cta-text-1-styles": {"display": "none"},
						"bottom-banner-star-styles": {"display": "none"},
						"bottom-banner-comment-styles": {"display": "none"},
						"bottom-banner-comment-duration": 0,
						"bottom-banner-comment-0-rating": 95,
						"bottom-banner-comment-0-name": "",
						"bottom-banner-comment-0-text": "",
						"bottom-banner-comment-1-rating": 100,
						"bottom-banner-comment-1-name": "",
						"bottom-banner-comment-1-text": "",
						"bottom-banner-comment-2-rating": 80,
						"bottom-banner-comment-2-name": "",
						"bottom-banner-comment-2-text": "",
						"bottom-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"bottom-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					},
					top: {
						"top-banner": true,
						"top-banner-button-animation": false,
						"top-banner-rating": 90,
						"top-banner-rating-styles": {"display": "none"},
						"top-banner-background-styles": {"width": 6000, "top": 0, "left": -3000, "borderRadius": 0, "backgroundColor": "#ffffff", "opacity": 1, "display": "block"},
						"top-banner-content-styles": {"width": 6000, "top": 0, "left": -3000, "display": "block"},
						"top-banner-icon-styles": {"display": "none"},
						"top-banner-title-text": "banner x",
						"top-banner-title-styles": {"width": 6000, "left": 0, "top": 10, "height": "100%", "color": "#d3028b", "fontFamily": "Arista-Pro-Alternate-Regular", "fontSize": 150, "fontWeight": "400", "fontStyle": "normal", "textAlign": "center", "lineHeight": 250, "display": "block"},
						"top-banner-description-text": "",
						"top-banner-description-styles": {"display": "none"},
						"top-banner-button-text": "",
						"top-banner-button-styles": {"display": "none"},
						"top-banner-cta-text-0-text": "",
						"top-banner-cta-text-0-styles": {"display": "none"},
						"top-banner-cta-text-1-text": "",
						"top-banner-cta-text-1-styles": {"display": "none"},
						"top-banner-star-styles": {"display": "none"},
						"top-banner-comment-styles": {"display": "none"},
						"top-banner-comment-duration": 0,
						"top-banner-comment-0-rating": 95,
						"top-banner-comment-0-name": "",
						"top-banner-comment-0-text": "",
						"top-banner-comment-1-rating": 100,
						"top-banner-comment-1-name": "",
						"top-banner-comment-1-text": "",
						"top-banner-comment-2-rating": 80,
						"top-banner-comment-2-name": "",
						"top-banner-comment-2-text": "",
						"top-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"top-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					}
				},
				{
					bottom: {
						"bottom-banner": true,
						"bottom-banner-rating": 90,
						"bottom-banner-button-animation": true,
						"bottom-banner-rating-styles": {"display": "none"},
						"bottom-banner-background-styles": {"width": 6000, "bottom": 0, "left": -3000, "borderRadius": 20, "backgroundColor": "#ffffff", "opacity": "1"},
						"bottom-banner-content-styles": {"width": 6000, "bottom": 0, "left": -3000},
						"bottom-banner-icon-styles": {"width": 200, "height": 200, "left": 2385, "top": 26, "borderRadius": 20},
						"bottom-banner-title-text": "Slices",
						"bottom-banner-title-styles": {"left": 2615, "top": 13, "color": "#333333", "fontFamily": "Arial", "fontSize": 80, "fontWeight": "600", "fontStyle": "normal"},
						"bottom-banner-description-text": "4.8",
						"bottom-banner-description-styles": {"left": 2620, "bottom": 85, "color": "#555555", "fontFamily": "Arial", "fontSize": 45, "fontWeight": "600", "fontStyle": "normal"},
						"bottom-banner-button-text": "Download",
						"bottom-banner-button-styles": {"width": 380, "height": 130, "left": 3200, "top": 60, "lineHeight": 130, "backgroundColor": "#5c8998", "color": "#ffffff", "borderRadius": 70, "fontFamily": "Arial", "fontSize": 50, "fontWeight": "600", "fontStyle": "normal"},
						"bottom-banner-cta-text-0-text": "(19,782)",
						"bottom-banner-cta-text-0-styles": {"left": 2772, "bottom": 85, "color": "#555555", "fontFamily": "Arial", "fontSize": 45, "fontWeight": "600", "fontStyle": "normal"},
						"bottom-banner-cta-text-1-text": "App Store",
						"bottom-banner-cta-text-1-styles": {"left": 2620, "bottom": 18, "color": "#555555", "fontFamily": "Arial", "fontSize": 45, "fontWeight": "600", "fontStyle": "normal"},
						"bottom-banner-star-styles": {"width": 45, "height": 45, "left": 2705, "bottom": 87, "display": "block"},
						"bottom-banner-comment-styles": {"display": "none"},
						"bottom-banner-comment-duration": 0,
						"bottom-banner-comment-0-rating": 95,
						"bottom-banner-comment-0-name": "",
						"bottom-banner-comment-0-text": "",
						"bottom-banner-comment-1-rating": 100,
						"bottom-banner-comment-1-name": "",
						"bottom-banner-comment-1-text": "",
						"bottom-banner-comment-2-rating": 80,
						"bottom-banner-comment-2-name": "",
						"bottom-banner-comment-2-text": "",
						"bottom-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"bottom-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					},
					top: {
						"top-banner": true,
						"top-banner-rating": 90,
						"top-banner-button-animation": true,
						"top-banner-rating-styles": {"display": "none"},
						"top-banner-background-styles": {"width": 6000, "top": 0, "left": -3000, "borderRadius": 20, "backgroundColor": "#ffffff", "opacity": "1"},
						"top-banner-content-styles": {"width": 6000, "top": 0, "left": -3000},
						"top-banner-icon-styles": {"width": 200, "height": 200, "left": 2385, "top": 26, "borderRadius": 20},
						"top-banner-title-text": "Slices",
						"top-banner-title-styles": {"left": 2615, "top": 13, "color": "#333333", "fontFamily": "Arial", "fontSize": 80, "fontWeight": "600", "fontStyle": "normal"},
						"top-banner-description-text": "4.8",
						"top-banner-description-styles": {"left": 2620, "bottom": 85, "color": "#555555", "fontFamily": "Arial", "fontSize": 45, "fontWeight": "600", "fontStyle": "normal"},
						"top-banner-button-text": "Download",
						"top-banner-button-styles": {"width": 380, "height": 130, "left": 3200, "top": 60, "lineHeight": 130, "backgroundColor": "#5c8998", "color": "#ffffff", "borderRadius": 70, "fontFamily": "Arial", "fontSize": 50, "fontWeight": "600", "fontStyle": "normal"},
						"top-banner-cta-text-0-text": "(19,782)",
						"top-banner-cta-text-0-styles": {"left": 2772, "bottom": 85, "color": "#555555", "fontFamily": "Arial", "fontSize": 45, "fontWeight": "600", "fontStyle": "normal"},
						"top-banner-cta-text-1-text": "App Store",
						"top-banner-cta-text-1-styles": {"left": 2620, "bottom": 18, "color": "#555555", "fontFamily": "Arial", "fontSize": 45, "fontWeight": "600", "fontStyle": "normal"},
						"top-banner-star-styles": {"width": 45, "height": 45, "left": 2705, "bottom": 87, "display": "block"},
						"top-banner-comment-styles": {"display": "none"},
						"top-banner-comment-duration": 0,
						"top-banner-comment-0-rating": 95,
						"top-banner-comment-0-name": "",
						"top-banner-comment-0-text": "",
						"top-banner-comment-1-rating": 100,
						"top-banner-comment-1-name": "",
						"top-banner-comment-1-text": "",
						"top-banner-comment-2-rating": 80,
						"top-banner-comment-2-name": "",
						"top-banner-comment-2-text": "",
						"top-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"top-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					}
				},
				{
					bottom: {
						"bottom-banner": true,
						"bottom-banner-rating": 90,
						"bottom-banner-button-animation": true,
						"bottom-banner-rating-styles": {"width": 220, "height": 36, "left": 320, "bottom": 46},
						"bottom-banner-background-styles": {"width": 1240, "bottom": 0, "left": -620, "borderRadius": 20, "backgroundColor": "#ffffff", "opacity": 1},
						"bottom-banner-content-styles": {"width": 1240, "bottom": 0, "left": -620},
						"bottom-banner-icon-styles": {"width": 200, "height": 200, "left": 25, "top": 26, "borderRadius": 20},
						"bottom-banner-title-text": "Slices",
						"bottom-banner-title-styles": {"left": 250, "top": 30, "color": "#333333", "fontFamily": "Arial", "fontSize": 80, "fontWeight": "400", "fontStyle": "normal"},
						"bottom-banner-description-text": "4.8",
						"bottom-banner-description-styles": {"left": 250, "bottom": 42, "color": "#555555", "fontFamily": "Arial", "fontSize": 40, "fontWeight": "400", "fontStyle": "normal"},
						"bottom-banner-button-text": "Download",
						"bottom-banner-button-styles": {"width": 380, "height": 130, "left": 810, "top": 60, "lineHeight": 130, "backgroundColor": "#00a2da", "color": "#ffffff", "borderRadius": 70, "fontFamily": "Arial", "fontSize": 50, "fontWeight": "600", "fontStyle": "normal"},
						"bottom-banner-cta-text-0-text": "App Store",
						"bottom-banner-cta-text-0-styles": {"left": 555, "bottom": 42, "color": "#555555", "fontFamily": "Arial", "fontSize": 40, "fontWeight": "400", "fontStyle": "normal"},
						"bottom-banner-cta-text-1-text": "",
						"bottom-banner-cta-text-1-styles": {"display": "none"},
						"bottom-banner-star-styles": {"width": 60, "height": 60, "left": 2710, "bottom": 25, "display": "block"},
						"bottom-banner-comment-styles": {"display": "none"},
						"bottom-banner-comment-duration": 0,
						"bottom-banner-comment-0-rating": 95,
						"bottom-banner-comment-0-name": "",
						"bottom-banner-comment-0-text": "",
						"bottom-banner-comment-1-rating": 100,
						"bottom-banner-comment-1-name": "",
						"bottom-banner-comment-1-text": "",
						"bottom-banner-comment-2-rating": 80,
						"bottom-banner-comment-2-name": "",
						"bottom-banner-comment-2-text": "",
						"bottom-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"bottom-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					},
					top: {
						"top-banner": true,
						"top-banner-rating": 90,
						"top-banner-button-animation": true,
						"top-banner-rating-styles": {"width": 220, "height": 36, "left": 320, "bottom": 46},
						"top-banner-background-styles": {"width": 1240, "top": 0, "left": -620, "borderRadius": 20, "backgroundColor": "#ffffff", "opacity": 1},
						"top-banner-content-styles": {"width": 1240, "top": 0, "left": -620},
						"top-banner-icon-styles": {"width": 200, "height": 200, "left": 25, "top": 26, "borderRadius": 20},
						"top-banner-title-text": "Slices",
						"top-banner-title-styles": {"left": 245, "top": 30, "color": "#333333", "fontFamily": "Arial", "fontSize": 80, "fontWeight": "400", "fontStyle": "normal"},
						"top-banner-description-text": "4.8",
						"top-banner-description-styles": {"left": 250, "bottom": 42, "color": "#555555", "fontFamily": "Arial", "fontSize": 40, "fontWeight": "400", "fontStyle": "normal"},
						"top-banner-button-text": "Download",
						"top-banner-button-styles": {"width": 380, "height": 130, "left": 810, "top": 60, "lineHeight": 130, "backgroundColor": "#00a2da", "color": "#ffffff", "borderRadius": 70, "fontFamily": "Arial", "fontSize": 50, "fontWeight": "600", "fontStyle": "normal"},
						"top-banner-cta-text-0-text": "App Store",
						"top-banner-cta-text-0-styles": {"left": 555, "bottom": 42, "color": "#555555", "fontFamily": "Arial", "fontSize": 40, "fontWeight": "400", "fontStyle": "normal"},
						"top-banner-cta-text-1-text": "",
						"top-banner-cta-text-1-styles": {"display": "none"},
						"top-banner-star-styles": {"width": 60, "height": 60, "left": 2710, "bottom": 25, "display": "block"},
						"top-banner-comment-styles": {"display": "none"},
						"top-banner-comment-duration": 0,
						"top-banner-comment-0-rating": 95,
						"top-banner-comment-0-name": "",
						"top-banner-comment-0-text": "",
						"top-banner-comment-1-rating": 100,
						"top-banner-comment-1-name": "",
						"top-banner-comment-1-text": "",
						"top-banner-comment-2-rating": 80,
						"top-banner-comment-2-name": "",
						"top-banner-comment-2-text": "",
						"top-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"top-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					}
				},
				{
					bottom: {
						"bottom-banner": true,
						"bottom-banner-rating": 90,
						"bottom-banner-button-animation": true,
						"bottom-banner-rating-styles": {"width": 190, "height": 30, "left": 244, "top": 70},
						"bottom-banner-background-styles": {"width": 1240, "bottom": 0, "left": -620, "borderRadius": 20, "backgroundColor": "#ffffff", "opacity": 1},
						"bottom-banner-content-styles": {"width": 1240, "bottom": 0, "left": -620},
						"bottom-banner-icon-styles": {"width": 200, "height": 200, "left": 25, "top": 26, "borderRadius": 20},
						"bottom-banner-title-text": "",
						"bottom-banner-title-styles": {"left": 245, "top": 18, "color": "#333333", "fontFamily": "Arial", "fontSize": 40, "fontWeight": "600", "fontStyle": "normal"},
						"bottom-banner-description-text": "",
						"bottom-banner-description-styles": {"display": "none"},
						"bottom-banner-button-text": "Download",
						"bottom-banner-button-styles": {"width": 380, "height": 130, "left": 830, "top": 60, "lineHeight": 130, "backgroundColor": "#00a2da", "color": "#ffffff", "borderRadius": 70, "fontFamily": "Arial", "fontSize": 50, "fontWeight": "600", "fontStyle": "normal"},
						"bottom-banner-cta-text-0-text": "",
						"bottom-banner-cta-text-0-styles": {"display": "none"},
						"bottom-banner-cta-text-1-text": "",
						"bottom-banner-cta-text-1-styles": {"display": "none"},
						"bottom-banner-star-styles": {"display": "none"},
						"bottom-banner-comment-duration": 5000,
						"bottom-banner-comment-styles": {"width": 550, "height": 110, "left": 250, "top": 115, "color": "#555555", "fontFamily": "Arial", "fontSize": 30, "fontWeight": "400", "fontStyle": "normal"},
						"bottom-banner-comment-0-rating": 95,
						"bottom-banner-comment-0-name": "Aishwarya Ramesh",
						"bottom-banner-comment-0-text": "I really like it, its helps you to sharpen you brain and the levels get more and more challenging.",
						"bottom-banner-comment-1-rating": 100,
						"bottom-banner-comment-1-name": "Riley Brooker",
						"bottom-banner-comment-1-text": "I love this game! It gets on my nerves a bit though. I highly recommend it to anyone.",
						"bottom-banner-comment-2-rating": 80,
						"bottom-banner-comment-2-name": "Emily Hoag",
						"bottom-banner-comment-2-text": "Played 3 rounds and it asked me to leave this. I can see myself losing hours in this game.",
						"bottom-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"bottom-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					},
					top: {
						"top-banner": true,
						"top-banner-rating": 90,
						"top-banner-button-animation": true,
						"top-banner-rating-styles": {"width": 190, "height": 30, "left": 244, "top": 70},
						"top-banner-background-styles": {"width": 1240, "top": 0, "left": -620, "borderRadius": 20, "backgroundColor": "#ffffff", "opacity": 1},
						"top-banner-content-styles": {"width": 1240, "top": 0, "left": -620},
						"top-banner-icon-styles": {"width": 200, "height": 200, "left": 25, "top": 26, "borderRadius": 20},
						"top-banner-title-text": "",
						"top-banner-title-styles": {"left": 245, "top": 18, "color": "#333333", "fontFamily": "Arial", "fontSize": 40, "fontWeight": "600", "fontStyle": "normal"},
						"top-banner-description-text": "",
						"top-banner-description-styles": {"display": "none"},
						"top-banner-button-text": "Download",
						"top-banner-button-styles": {"width": 380, "height": 130, "left": 830, "top": 60, "lineHeight": 130, "backgroundColor": "#00a2da", "color": "#ffffff", "borderRadius": 70, "fontFamily": "Arial", "fontSize": 50, "fontWeight": "600", "fontStyle": "normal"},
						"top-banner-cta-text-0-text": "",
						"top-banner-cta-text-0-styles": {"display": "none"},
						"top-banner-cta-text-1-text": "",
						"top-banner-cta-text-1-styles": {"display": "none"},
						"top-banner-star-styles": {"display": "none"},
						"top-banner-comment-duration": 5000,
						"top-banner-comment-styles": {"width": 550, "height": 110, "left": 250, "top": 115, "color": "#555555", "fontFamily": "Arial", "fontSize": 30, "fontWeight": "400", "fontStyle": "normal"},
						"top-banner-comment-0-rating": 95,
						"top-banner-comment-0-name": "Aishwarya Ramesh",
						"top-banner-comment-0-text": "I really like it, its helps you to sharpen you brain and the levels get more and more challenging.",
						"top-banner-comment-1-rating": 100,
						"top-banner-comment-1-name": "Riley Brooker",
						"top-banner-comment-1-text": "I love this game! It gets on my nerves a bit though. I highly recommend it to anyone.",
						"top-banner-comment-2-rating": 80,
						"top-banner-comment-2-name": "Emily Hoag",
						"top-banner-comment-2-text": "Played 3 rounds and it asked me to leave this. I can see myself losing hours in this game.",
						"top-banner-star": {"backgroundImage": "url(Images/banner-star.png)"},
						"top-banner-icon": {"backgroundImage": "url(Images/banner-icon.png)"}
					}
				}
			];

			return {
				currentBannerId: 0
			};

		},
		mounted() {

			//Сообщаем компоненту что он должен обновляться при изменении текущей настройки активной версии креатива
			this.addUpdateEvent(`Selected Version Setting Changed:${this.prefix}-banner-id`);

		},
		methods: {
			collectData() {

				this.currentBannerId = Settings.getSettingValue(`${this.prefix}-banner-id`);

				this.currentBannerId = this.currentBannerId === null ? 1 : this.currentBannerId;

			},
			setBanner(id) {

				Broadcast.call("Pseudo Modal Hide", [this._uid + 'banner-control-dropdown']);

				const prefix = this.prefix;

				for (let key in this.settings[id][prefix]) {

					if (!this.settings[id][prefix].hasOwnProperty(key)) continue;

					Settings.setSettingValue(key, this.settings[id][prefix][key]);

				}

				this.currentBannerId = id;

				Settings.setSettingValue(`${prefix}-banner-id`, id);

				Broadcast.call("Update Settings Content", []);

			}
		}
	}
</script>


<style lang="sass">

	.banner-control
		font-size: 0.875rem
		display: flex
		justify-content: space-between
		height: 45px

		.title
			align-self: center
			width: 110px

		.banner-options-button
			cursor: pointer
			font-size: 0.875rem
			width: 200px
			height: 45px
			align-self: center
			background-size: contain
			background-repeat: no-repeat
			background-position: center center

		.dropdown-menu
			right: 0
			top: 0
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

		.banner-template
			width: 100%
			height: 45px
			background-size: 96% auto
			background-repeat: no-repeat
			background-position: center center

		.banner-template-0
			background-image: url("./../../assets/banner-template-0.png")

		.banner-template-1
			background-image: url("./../../assets/banner-template-1.png")

		.banner-template-2
			background-image: url("./../../assets/banner-template-2.png")

		.banner-template-3
			background-image: url("./../../assets/banner-template-3.png")

		.banner-template-4
			background-image: url("./../../assets/banner-template-4.png")

		.banner-template-5
			background-image: url("./../../assets/banner-template-5.png")

		.banner-template-6
			background-image: url("./../../assets/banner-template-6.png")

</style>

